import { makeStyles } from "@mui/styles"
import { colors } from "../../utils"

const useStyles = makeStyles((theme) => ({
  //   container: {
  //     position: "relative",
  //   },

  title: {
    "&.MuiTypography-root": {
      fontWeight: "bold",
      fontSize: "1.4rem",
      color: colors.primary,
      textAlign: "left",
    },
  },

  subTitle: {
    fontSize: "1em",
    margin: "18px 0",
  },

  body: {
    display: "flex",
    flexDirection: "row",
    fontSize: "1.1rem",
    width: "100%",
    [theme.breakpoints.up("xl")]: {
      height: "100%",
    },
  },

  formBody: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "90%",
    margin: "0 auto",
    [theme.breakpoints.up("lg")]: {
      flexDirection: "row",
    },
  },

  form: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    fontSize: "1em",
    color: colors.greyStrong,
  },

  formHeader: {
    display: "flex",
    margin: "35px auto 0 auto",
    width: "90%",
  },

  formA: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    [theme.breakpoints.up("lg")]: {
      width: "48%",
    },
  },

  direction: {
    marginTop: "25px",
    position: "relative",
  },

  nameLastname: {
    position: "relative",
  },

  boxs: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    marginTop: "25px",
    width: "100%",
    [theme.breakpoints.up("lg")]: {
      flexDirection: "row",
    },
  },

  firstLineB: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: "100%",
    [theme.breakpoints.up("lg")]: {
      flexDirection: "row",
    },
  },

  pqrTypeContainer: {
    position: "relative",
    width: "100%",
    [theme.breakpoints.up("lg")]: {
      width: "52%",
    },
  },

  whoResidesContainer: {
    position: "relative",
    width: "100%",
    [theme.breakpoints.down("lg")]: {
      marginTop: "25px",
    },
    [theme.breakpoints.up("lg")]: {
      width: "45%",
    },
  },

  buttons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    margin: "150px 30px 30px",
    position: "relative",
  },

  inputButton: {
    "&.MuiButton-root": {
      marginLeft: "50px",
      width: "150px",
    },
  },

  cancel: {
    "&.MuiButton-root": {
      textDecoration: "underline",
      fontWeight: "bold",
      textTransform: "none",
      fontSize: "1.1em",
    },
  },

  age: {
    position: "relative",
    [theme.breakpoints.up("lg")]: {
      width: "25%",
    },
  },

  email: {
    width: "100%",
  },

  emailContainer: {
    width: "100%",
    position: "relative",
    [theme.breakpoints.up("lg")]: {
      width: "72%",
    },
    [theme.breakpoints.down("lg")]: {
      marginTop: "25px",
    },
  },

  documentTypeContainer: {
    width: "100%",
    position: "relative",
    [theme.breakpoints.up("lg")]: {
      width: "52%",
    },
  },

  documentNumContainer: {
    width: "100%",
    position: "relative",
    [theme.breakpoints.down("lg")]: {
      marginTop: "25px",
    },
    [theme.breakpoints.up("lg")]: {
      width: "45%",
    },
  },

  genderContainer: {
    width: "100%",
    position: "relative",
    [theme.breakpoints.up("lg")]: {
      width: "42%",
    },
  },

  phoneContainer: {
    width: "100%",
    position: "relative",
    [theme.breakpoints.down("lg")]: {
      marginTop: "25px",
    },
    [theme.breakpoints.up("lg")]: {
      width: "55%",
    },
  },

  phone: {
    width: "100%",
  },

  stateContainer: {
    width: "100%",
    position: "relative",
    [theme.breakpoints.up("lg")]: {
      width: "55%",
    },
  },

  countiesContainer: {
    width: "100%",
    position: "relative",
    [theme.breakpoints.down("lg")]: {
      marginTop: "25px",
    },
    [theme.breakpoints.up("lg")]: {
      width: "42%",
    },
  },

  sedeContainer: {
    width: "100%",
    position: "relative",
    [theme.breakpoints.down("lg")]: {
      marginTop: "25px",
    },
    [theme.breakpoints.up("lg")]: {
      width: "53%",
    },
  },

  epsContainer: {
    width: "100%",
    position: "relative",
    [theme.breakpoints.up("lg")]: {
      width: "44%",
    },
  },

  descripitionContainer: {
    marginTop: "25px",
    position: "relative",
  },

  services: {
    marginTop: "25px",
    position: "relative",
  },

  formB: {
    width: "100%",
    [theme.breakpoints.up("lg")]: {
      width: "48%",
    },
    [theme.breakpoints.down("lg")]: {
      marginTop: "25px",
    },
  },

  imgContainer: {
    // margin: "50px 0 0 70px",
  },

  formImg: {
    width: "90%",
    // [theme.breakpoints.up("xl")]: {
    //   width: "90%",
    // },
  },

  pqrType: {
    margin: "0 auto",
    textAlign: "center",
    width: "48%",
  },

  pqrTypeImg: {
    [theme.breakpoints.up("lg")]: {
      margin: "auto 0",
      textAlign: "center",
      width: "48%",
    },
    [theme.breakpoints.down("xl")]: {
      display: "none",
    },
    [theme.breakpoints.up("xxl")]: {
      margin: "40px 0",
    },
  },

  errorContainer: {
    position: "absolute",
    top: "50px",
    left: "5px",
    // [theme.breakpoints.up("lg")]: {
    //   top: "50px",
    // },
  },

  errorContainerDescription: {
    position: "absolute",
    top: "109px",
    left: "5px",
  },

  addFile: {
    textTransform: "none",
    "&.MuiTypography-root": {
      fontSize: "1rem",
      marginRight: "10px",
    },
  },

  fileContainer: {
    position: "relative",
    marginTop: "25px",
  },

  file: {
    display: "flex",
    alignItems: "center",
    width: "50%",
    justifyContent: "space-between",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },

  fileFullWidth: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  fileNameContainer: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    display: "flex",
    flexDirection: "row",
  },

  fileName: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },

  fileSize: {
    marginLeft: "5px",
  },

  fileList: {
    marginTop: "30px",
    display: "flex",
    flexWrap: "wrap",
    maxHeight: "110px",
    flexDirection: "column",
    position: "absolute",
    top: "4.5rem",
    left: "5px",
    width: "100%",
    // [theme.breakpoints.up("xl")]: {
  },

  errorContainerFiles: {
    position: "absolute",
    top: "42px",
    left: "5px",
    display: "flex",
    flexDirection: "column",
    // [theme.breakpoints.up("lg")]: {
    //   top: "37px",
    // },
  },

  addButton: {
    width: "100%",
    "&.MuiButton-outlined": {
      borderColor: colors.borderGrey,
      "&:hover": {
        borderColor: colors.black,
      },
    },
    "&.MuiButton-root": {
      justifyContent: "space-between",
      color: colors.greyStrong,
    },
  },

  addButtonError: {
    width: "100%",
    "&.MuiButton-outlined": {
      borderColor: colors.danger,
      "&:hover": {
        borderColor: colors.deepDanger,
      },
    },
    "&.MuiButton-root": {
      justifyContent: "space-between",
      color: colors.danger,
    },
  },
}))

export default useStyles
